import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { LanguageProvider } from "./LanguageContext"; // Import the provider
import "@fortawesome/fontawesome-free/css/all.min.css";

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
